import { ReportDataIssueContextType } from '../../constants/events'

export type ReportReason = {
  key: string
  value: string
}

export type ReportDataIssueConfig = {
  dialogTitle?: string
  reasons?: ReportReason[]
  reasonsLabel?: string
  reasonsRequiredMessage?: string
  descriptionLabel?: string
  descriptionPlaceholder?: string
  descriptionRequiredMessage?: string
  descriptionMaxLengthMessage?: string
  maxDescriptionLength?: number
  sendButtonLabel?: string
  cancelButtonLabel?: string
  confirmation?: {
    title?: string
    message?: string
    nextStepsLabel?: string
    nextStep1?: string
    nextStep2?: string
    contactUsLabel?: string
    contactEmail?: string
    backToSiteLabel?: string
    backToAssetLabel?: string
  }
  unsavedChanges?: {
    message?: string
    subtext?: string
    yesLabel?: string
    noLabel?: string
  }
}

export type CopReportDataIssueProps = {
  configJson?: string
  'config-json'?: string
}

export type ActiveContext = {
  type: ReportDataIssueContextType
  id?: string
  name?: string
}

const FALLBACK_MAX_DESCRIPTION_LENGTH = 3000

function decodeHtmlEntities(str: string): string {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = str
  return textarea.value
}

export function parseConfig(raw: string): ReportDataIssueConfig {
  if (!raw) {
    return {}
  }

  try {
    const parsed = JSON.parse(decodeHtmlEntities(raw)) as ReportDataIssueConfig
    return parsed ?? {}
  } catch {
    return {}
  }
}

export function getMaxLength(value?: number): number {
  if (!value || value <= 0) {
    return FALLBACK_MAX_DESCRIPTION_LENGTH
  }
  return value
}